export default "__VITE_ASSET__DgVTce5R__"